import { Observable } from "rxjs/Observable"

export interface IDropdownField {
      lable?: string,
      placeholder?: string,
      selectValue?: any,
      formControlName?: string,
      isRequired?: boolean,
      isServerError?: boolean,
      serverErrorText?: string,
      isReadOnly?: boolean,
      isMultipleSelect?: boolean,
      isSearch?: boolean,
      dropdownList: any[],
      isValueBind?: boolean, // on select emit value and also bind with value
      isFullObject?: boolean, // on select emit full item
      dataField?: string,
      isYearDropdown?: any,
      isFocus?: boolean,
      preventDuplicateEmit?: boolean;
      enableBulkPaste?: boolean; //added by BURHAN - 5-August-2026
      addTag?: any; //added by BURHAN - 5-August-2026
      enableBulkValidation?: boolean; //added by BURHAN - 5-August-2026
}
export interface IList {
      name: string,
      value: any
}
export class YearPickerDataModel {
      name: string | number | null = null;
      startYear: string | number | null = null;
      endYear: string | number | null = null;
}
export class YearDetailsModel {
      yearFrom: number | null = null;
      yearTo: number | null = null;
      isShowFromToYear: boolean = null;
} 